import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, EmployeesResponseData } from "schema"

type Query = {
  page?: number
  query?: string
}

type EmployeesResponse = DataResponse<EmployeesResponseData>

export const getEmployeesQueryKey = (query: Query = {}) => ["employees", query]

type Props = {
  query?: Query
}

export const employeesQuery = ({ query }: Props = {}) => {
  return queryOptions({
    queryKey: getEmployeesQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<EmployeesResponse>("/employees", { params: query })
      return data.data
    },
  })
}
